/**
 * @generated SignedSource<<fada755ffc7229141a13c0afef22ac62>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type getCachedPageTitle_ContentTitleFragment$data = {
  readonly id: string | null;
  readonly title: string | null;
  readonly " $fragmentType": "getCachedPageTitle_ContentTitleFragment";
};
export type getCachedPageTitle_ContentTitleFragment$key = {
  readonly " $data"?: getCachedPageTitle_ContentTitleFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"getCachedPageTitle_ContentTitleFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "getCachedPageTitle_ContentTitleFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "title"
    }
  ],
  "type": "Content"
};

(node as any).hash = "1115adb3266e3c279996feed3d6fdcd5";

export default node;
